import styles from "./actionList.module.scss";
import { Link } from "react-router-dom";

const ActionsList = ({actionItem, users, activeTab }) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  const creationDate = new Date(actionItem.CreationDate);
  const creationDateStr = `${creationDate.getDate()} ${months[creationDate.getMonth()]}, ${creationDate.getFullYear()}`;
  const lastUpdate = new Date(actionItem.LastUpdate);
  const lastUpdateStr = `${lastUpdate.getDate()} ${months[lastUpdate.getMonth()]}, ${lastUpdate.getFullYear()}`;
  
  const findNameByEmail = (email) => {
    const user = users.find(user => user.email === email);
    return user ? user.name : 'Email not found';
  };

  const getInitials = (name) => {
    const parts = name.split(' ');
  
    let initials = '';
  
    parts.forEach(part => {
      if (part) {
        initials += part.charAt(0).toUpperCase();
      }
    });
  
    return initials;
  }
  
  return (
    <>
      <div className={styles.itemCard}>

        <div className={styles.icon}>
          <span className={styles.avatar} title={findNameByEmail(actionItem.CreatedByEmail)}>
            {getInitials(findNameByEmail(actionItem.CreatedByEmail))}
          </span>

        </div>
        
        <div className={styles.details}>
          <div className={styles.name}><Link to={activeTab === "draft" ? `/products/create-shared-data?id=${actionItem.ProductId}&actionId=${actionItem.id}` : `/reviewItem?id=${actionItem.id}&tab=${activeTab}`}>{actionItem.ModelNumber}</Link></div>
        </div>
        <div className={styles.time}>
          <div className={styles.createdBy}><span>Created On:</span> {creationDateStr} </div>
          <div className={styles.createdBy}>{findNameByEmail(actionItem.CreatedByEmail)} </div>
        </div>
        <div className={styles.time}>
          <div className={styles.lastActivity}><span>Last Activity:</span> {lastUpdateStr}<br /></div>
          <div className={styles.lastActivity}>{findNameByEmail(actionItem.CreatedByEmail)}</div>
        </div>

        <div className={styles.status}>
          <span>Status: </span>
          {actionItem.Status}
        </div>
        <div className={styles.activity}>
          <span>State: </span>
          {actionItem.State !=null ? actionItem.State : '--'}
        </div>
        <div className={styles.approver}>
          Approver: {findNameByEmail(actionItem.ReviewerEmail)}
        </div>

      </div>
    </>
  );
};

export default ActionsList;